import clsx from "clsx";
import classes from "./SuccessContainer.module.css";
import Header from "../Header/Header";
import { Button } from "components/common";
import { FaArrowRightLong } from "react-icons/fa6";
const SuccessContainer = ({ heading, info, buttonText, to }) => {
  return (
    <div className={clsx(classes.container, "container")}>
      <Header heading={heading} info={info} success />
      <Button to={to || "/dahsboard"}>
        {buttonText || "Go to Dahsboard"}
        <FaArrowRightLong className={classes.icon} />
      </Button>
    </div>
  );
};
export default SuccessContainer;
